<div class="flex justify-content-center align-items-center w-full h-screen">
    <p-tag icon="pi pi-exclamation-triangle" severity="warning"  class="h-10rem p-6" value="Something went wrong... please try again later" />

</div>
